const { Stack, IconButton } = require("@mui/material")
const { default: IndieTextField } = require("./IndieTextField")
const { OpenInNewOutlined } = require("@mui/icons-material")
const { Link } = require("react-router-dom")

const TextFieldWithLink = ({ link, linkPermissions, ...props }) => {
    return (
        <Stack direction="row" spacing={2} sx={{ display: "flex", alignItems: "baseline" }}>
            <IndieTextField {...props} disabled />
            {link && (
                <IconButton component={Link} to={link} target="_blank" size="small" color="primary" aria-label="back">
                    <OpenInNewOutlined />
                </IconButton>
            )}
        </Stack>
    )
}

export default TextFieldWithLink;